import { apiCallResetAccount } from "../../../api/user-api/api-call-reset-account";
import getCorePopUpStore from "../../core/core-popup-store";
import getCoreUIStore from "../../core/core-ui-store";

const resetAccountOnDatabase = async (userUUID: string) => {
  try {
    getCoreUIStore().setIsLoading("USER_ADVANCED", true);
    const { data, status, code } = await apiCallResetAccount({
      userUUID
    });
    if (status === "OK") {
      getCorePopUpStore().showSuccessMessage("USER_RESET_SUCCESSFULLY");
      getCoreUIStore().setIsLoading("USER_ADVANCED", false);
      return data;
    }
    getCorePopUpStore().showAlertMessage(code);
    getCoreUIStore().setIsLoading("USER_ADVANCED", false);
    return code;
  } catch (error) {
    getCoreUIStore().setIsLoading("USER_ADVANCED", false);
    return error;
  }
};

export default resetAccountOnDatabase;
